import { gql } from '@apollo/client/core'

export const CHAT_CHANNEL_FIELDS = `id type name createdById createdAt members { id channelId employeeId lastReadAt employee { id name photoUrl isActive } } lastMessage { id senderId body isEphemeral createdAt sender { id name } receipts { id employeeId viewedAt readAt }
      reactions { id employeeId emoji } } unreadCount`

export const CHAT_CHANNELS_QUERY = gql`
  query ChatChannels {
    unreadChatMessageCount
    chatChannels {
      ${CHAT_CHANNEL_FIELDS}
    }
  }
`

export const CHAT_MESSAGES_QUERY = gql`
  query ChatMessages($channelId: Int!, $cursor: Int) {
    chatMessages(channelId: $channelId, cursor: $cursor) {
      id channelId senderId body replyToId editedAt deletedAt isEphemeral createdAt
      sender { id name photoUrl isActive }
      receipts { id employeeId viewedAt readAt }
      reactions { id employeeId emoji }
    }
  }
`

export const CREATE_CHAT_CHANNEL = gql`
  mutation CreateChatChannel($type: String!, $name: String, $employeeIds: [String!]!) {
    createChatChannel(type: $type, name: $name, employeeIds: $employeeIds) {
      ${CHAT_CHANNEL_FIELDS}
    }
  }
`

export const SEND_CHAT_MESSAGE = gql`
  mutation SendChatMessage($channelId: Int!, $body: String!, $replyToId: Int, $isEphemeral: Boolean) {
    sendChatMessage(channelId: $channelId, body: $body, replyToId: $replyToId, isEphemeral: $isEphemeral) {
      id channelId senderId body replyToId editedAt deletedAt isEphemeral createdAt sender { id name photoUrl isActive }
      receipts { id employeeId viewedAt readAt }
      reactions { id employeeId emoji }
    }
  }
`

export const MARK_CHAT_CHANNEL_READ = gql`
  mutation MarkChatChannelRead($channelId: Int!) {
    markChatChannelRead(channelId: $channelId)
  }
`

export const DELETE_CHAT_MESSAGE = gql`
  mutation DeleteChatMessage($id: Int!) {
    deleteChatMessage(id: $id)
  }
`

export const TOGGLE_CHAT_REACTION = gql`
  mutation ToggleChatReaction($messageId: Int!, $emoji: String!) {
    toggleChatMessageReaction(messageId: $messageId, emoji: $emoji) {
      messageId
      reactions { id employeeId emoji }
      mine { id emoji }
    }
  }
`

export const UNREAD_CHAT_MESSAGE_COUNT = gql`
  query UnreadChatMessageCount {
    unreadChatMessageCount
  }
`
